var map = {
	"./screensTranslations_CZ.json": [
		6413,
		413
	],
	"./screensTranslations_DA.json": [
		6967,
		967
	],
	"./screensTranslations_DE.json": [
		1387,
		387
	],
	"./screensTranslations_EN.json": [
		7059,
		59
	],
	"./screensTranslations_ES.json": [
		9668,
		668
	],
	"./screensTranslations_FI.json": [
		4813,
		813
	],
	"./screensTranslations_FR.json": [
		5608,
		608
	],
	"./screensTranslations_MY.json": [
		3494,
		494
	],
	"./screensTranslations_PL.json": [
		9908,
		908
	],
	"./screensTranslations_PT.json": [
		8540,
		540
	],
	"./screensTranslations_SK.json": [
		4978,
		978
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8377;
module.exports = webpackAsyncContext;